import React, { useState, useEffect } from "react";
import { CustomersFileType } from "../Common/Types/types";
import Spinner from "../Common/Components/spinner";
import ErrorMessage from "../Common/Components/ErrorMessage";
import { CustomersApi } from "./api";
import {
  getCustomerListSelector,
  loadingCustomerListSelector,
} from "../Search/Slice";
import { useSelector } from "react-redux";
import { updateParams, getParamsSelector } from "../Common/Slices/ParamSlice";
import { useAppDispatch } from "../Core/store.hooks";

interface CustomerInfoWidgetProps {
  id: string;
  header: string;
  isBold: boolean;
}

const CustomersFilesWidget = (props: CustomerInfoWidgetProps) => {
  const [customerInfo, updateCustomerInfo] = useState(null);
  const [customerInfoLoading, updateCustomerInfoLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>(null);
    const [fontWeight, updateFontWeight] = useState("bold");
    const [color, updateColor] = useState("rgb(0, 88, 233)");

  const customerList: any = useSelector(getCustomerListSelector);
  const globalParams = useSelector(getParamsSelector);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (globalParams.customerID != null) {
      GetCustomerInfo();
    }
  }, [globalParams.customerID]);
  useEffect(() => {
    if (globalParams.mainMachineSerialNo == null) {
        updateFontWeight("bold"); updateColor("#000");
    } else {
        updateFontWeight("normal"); updateColor("rgb(0, 88, 233)");
    }
  }, [globalParams.mainMachineSerialNo]);
  const GetInfoFromCustomerCache = () => {
    if (customerList != null) {
      for (var i = 0; i < customerList.length; i++) {
        if (customerList[i].customerID == globalParams.customerID) {
          return customerList[i];
        }
      }
    }
    return null;
  };
  const GetCustomerInfo = () => {
    let cachedInfo: any = GetInfoFromCustomerCache();
    let fullInfo: boolean = false;
    if (cachedInfo != null) {
      if (
        cachedInfo.street != null &&
        cachedInfo.city != null &&
        cachedInfo.country != null
      ) {
        updateCustomerInfo(cachedInfo);
        fullInfo = true;
      }
    }
    if (!fullInfo) {
      updateCustomerInfoLoading(true);
      setErrorMessage(null);
      CustomersApi.getCustomerInfo({ customerId: globalParams.customerID })
        .then((response: any) => {
          updateCustomerInfo(response);
          updateCustomerInfoLoading(false);
          setErrorMessage(null);
        })
        .catch((error) => {
          if (error.message != "canceled") {
            updateCustomerInfoLoading(false);
            setErrorMessage("Oops something went wrong, unable to get data.");
          }
        });
    }
  };
  const selectCustomer = () => {
    const params: any = Object.assign({}, globalParams);
    params.mainMachineSerialNo = null;
    params.customerID = globalParams.customerID;
    params.machine = null;
    updateFontWeight("bold");

    dispatch<any>(updateParams(params));
  };
  if (customerInfoLoading == true) {
    return <Spinner text="data" />;
  }
  if (customerInfoLoading === false && customerInfo === null) {
    return (
      <>
        <br />
        <ErrorMessage text={errorMessage} id={props.id} header={props.header} />
      </>
    );
  }
  return (
    <div onClick={selectCustomer}>
      <span style={{ fontWeight: fontWeight,color:color, cursor: "pointer" }}>
        {customerInfo.customerName}, {customerInfo.customerID}
      </span>
      <br />
      {customerInfo.street}
      <br />
      {customerInfo.city}
      <br />
      {customerInfo.country}
    </div>
  );
};
export default CustomersFilesWidget;
